import { createContext } from "react";
import { CellFocusStore } from "./CellFocusStore";

export const CellFocusContext = createContext<CellFocusStore | null>(null);
